import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Args, Flags } from '@oclif/core';
import { Queue } from '@switchboard-xyz/on-demand';

export default class QueueSetNcn extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Set ncn for queue account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    ncn: Flags.string({
      description: 'The ncn account to set',
      required: false,
    }),
  };

  static args = {
    queue: Args.string({
      description: 'The queue account to configure',
    }),
  };

  async run() {
    const { args, flags } = await this.parse(
      this.constructor as typeof QueueSetNcn
    );

    const program = await this.program;

    const queue = new Queue(program, new web3.PublicKey(args.queue!));
    const ncn = new web3.PublicKey(flags.ncn!);
    const queueData = await queue.loadData();
    console.log(`Queue authority: ${queueData.authority.toString()}`);
    const ix = await queue.setNcnIx({
      ncn,
    });

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure queue account');
  }
}
